import { retentionViews } from './retention';

export const views = {
  CHART: 'Chart',
  COLUMN_CHART: 'Column chart',
  PIE_CHART: 'Pie chart',
  PERIOD_LINE_CHART: 'Period chart',
  TABLE: 'Table',
};

export const charts = [views.CHART, views.COLUMN_CHART, views.PIE_CHART];

export const BASIC_CHART_VIEWS = [
  views.CHART,
  views.COLUMN_CHART,
  retentionViews.CHART_BY_DATE,
  retentionViews.COLUMN_CHART_BY_DATE,
];

export const ALL_CHART_VIEWS = [views.CHART, views.COLUMN_CHART, views.PIE_CHART];

export const aggregationTypes = {
  COUNT: 'count',
  SUM: 'sum',
  MIN: 'min',
  MAX: 'max',
  AVG: 'avg',
  UNIQ: 'uniq',
  AVG_COUNT: 'avg_count',
  AVG_TOTAL: 'avg_total',
  AVG_COUNT_SPLIT: 'avg_count_split',
  AVG_TOTAL_SPLIT: 'avg_total_split',
};

export const usageEvents = {
  DAU: 'DAU',
  WAU: 'WAU',
  MAU: 'MAU',
};

export const paymentAmounts = ['amountCalculated', 'amount', 'amountNet', 'amountCalculatedNet'];

export const dateColumns = {
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
};

export const commonEvents = {
  REGISTER_FIRST_START: 'REGISTER_FIRST_START',
  DAU: 'DAU',
  WAU: 'WAU',
  MAU: 'MAU',
  SESSION_CLOSE: 'SESSION_CLOSE',
  PAYMENT: 'Payment',
};

export const chartAxes = {
  X: 'X',
  Y: 'Y',
};

export const ADDITIONAL_PERIODS_LIMITATION = 5;

export const splitPostfix = '.split';
